import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on all pages
    $('a[href*="#"]').on('click', function(event) {
      let hash = this.hash;
      if (hash) {
        event.preventDefault();
        $('html, body').animate({scrollTop: $(hash).offset().top - 200}, 750);
      }
    });

    //Sticky Header show/hide
    const showAnim = gsap.from('.sticky-header-wrap', { 
      yPercent: -125.36,
      paused: true,
      duration: 0.4,
    }).progress(1);
    
    ScrollTrigger.create({
      start: 'top top',
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
      },
    });

    gsap.defaults({overwrite: 'auto'});

    const ST = ScrollTrigger.create({
      trigger: '.content-container',
      start: 'top top-125px',
      end: 'bottom bottom',
      onUpdate: getCurrentSection,
      pin: '.left-content',
    });
    
    const contentMarkers = gsap.utils.toArray('.contentMarker');
    
    // Set up our content behaviors
    contentMarkers.forEach(marker => {
      marker.content = document.querySelector(`#${marker.dataset.markerContent}`);
      
      if(marker.content.tagName === 'DIV') {
        gsap.set(marker.content, {transformOrigin: 'center'});
        
        marker.content.enter = function() {
          if (jQuery('#'+marker.dataset.markerContent).css('visibility') == 'visible') return;
          gsap.fromTo(marker.content, {autoAlpha: 0}, {duration: 0.3, autoAlpha: 1, rotateY: 0});
        }
      } else if(marker.content.tagName === 'BLOCKQUOTE') {
        gsap.set(marker.content, {transformOrigin: 'left center'});
        
        marker.content.enter = function() {
          gsap.fromTo(marker.content, {autoAlpha: 0}, {duration: 0.3, autoAlpha: 1, rotateY: 0});
        }
      }
      
      marker.content.leave = function() {
        gsap.to(marker.content, {duration: 0.1, autoAlpha: 0});
      }
      
    });
    
    
    // Handle the updated position
    let lastContent;
    function getCurrentSection() {
      let newContent;
      const currScroll = scrollY;
      
      // Find the current section
      contentMarkers.forEach(marker => {
        if(currScroll > marker.offsetTop) {
          newContent = marker.content;
        }
      });
      
      // If the current section is different than that last, animate in
      if(newContent
      && (lastContent == null 
         || !newContent.isSameNode(lastContent))) {
        // Fade out last section
        if(lastContent) {
          lastContent.leave();
        }
        
        // Animate in new section
        newContent.enter();
        
        lastContent = newContent;
      }
      
    }
    
    
    
    const media = window.matchMedia('screen and (max-width: 600px)');
    ScrollTrigger.addEventListener('refreshInit', checkSTState);
    checkSTState();
    
    function checkSTState() {
      if(media.matches) {
        ST.disable();
      } else {
        ST.enable();
      }
    }

    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $('.video-content-block').each(function () {
      var video = $(this).find('video');
      var plainVideo = video.get(0);/*DOM video object, unwrapped from jQuery*/
      var playBtn = $(this).find('.video-btn');
      var videoImg = $(this).find('.video-cover-image');

      playBtn.click(function () {
          video.get(0).addEventListener('ended',myHandler,false);
          video.prop('controls',true); 
          plainVideo.play();
          playBtn.css('visibility', 'hidden');
          videoImg.fadeOut();

          function myHandler() {
              playBtn.css('visibility', 'visible');
          }
      });
    });

    $(document).ready(function(){
      $('body').addClass('loaded');
    });


  },
};

$('.tabbed-content .tab button').click(function () {
  var title = $(this).attr('id');
  var parent = $(this).closest('.containers');
  parent.find('.active').removeClass('active');
  $(this).addClass('active');
  parent.find('#' + title + 'Content').addClass('active');
});

$('a.nav-side-btn').click(function (event) {
  event.preventDefault();
  $('.side-nav').toggleClass('nav-open');
});

$('.nav-btn-close').click(function () {
  $('.side-nav').toggleClass('nav-open');
});

$(function() {
  $('.check-description').matchHeight();
  $('.check-price').matchHeight();
  $('.pricing-column h3').matchHeight();
  $('.pricing-column .pricing-text').matchHeight();
  $('.pricing-column .pricing-features').matchHeight();
  $('.pricing-column .price-info').matchHeight();
  $('.three-col-wrap').matchHeight();
});

$('a.cta-form-reveal').click(function(event){
  event.preventDefault();
  $('.cta-form').slideToggle();
});

$('body').on('click', 'a.hide-sign-up', function(event){
  event.preventDefault();
  $('.dent-sign-up-form').addClass('hide');
  $('.dent-login-form').removeClass('hide');
});

$('body').on('click', 'a.hide-login', function(event){
  event.preventDefault();
  $('.dent-sign-up-form').removeClass('hide');
  $('.dent-login-form').addClass('hide');
});

$('a.cta-form-active').click(function(event){
  event.preventDefault();
  var ctaForm = $(this).parent().parent().find('.book-cta-form');
  ctaForm.slideToggle();

  $([document.documentElement, document.body]).animate({
    scrollTop: $(ctaForm).offset().top,
  }, 2000);
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js